'use strict';

exports.__esModule = true;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _redux = require('redux');

var _pageReducers = require('./page-reducers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Action', {
	value: require('react').PropTypes.shape({
		type: require('react').PropTypes.string.isRequired,
		response: require('react').PropTypes.oneOfType([require('react').PropTypes.arrayOf(require('react').PropTypes.object), require('react').PropTypes.shape({
			matching_items: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
			__exact__: function __exact__(values, prop, displayName) {
				var props = {
					matching_items: true
				};
				var extra = [];

				for (var k in values) {
					if (values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
						extra.push(k);
					}
				}

				if (extra.length > 0) {
					return new Error('Invalid additional prop(s) ' + (0, _stringify2.default)(extra));
				}
			}
		})])
	})
});
exports.default = (0, _redux.combineReducers)({
	page: _pageReducers.page
});


// WEBPACK FOOTER //
// ./components/login-page/lib/reducers/index.js